// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file orders/used_order.proto (package app.dealzy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message app.dealzy.UpdateOrderStatusRequest
 */
export class UpdateOrderStatusRequest extends Message<UpdateOrderStatusRequest> {
  /**
   * @generated from field: int32 order_id = 1;
   */
  orderId = 0;

  /**
   * @generated from field: bool is_used = 2;
   */
  isUsed = false;

  constructor(data?: PartialMessage<UpdateOrderStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "app.dealzy.UpdateOrderStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_used", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOrderStatusRequest {
    return new UpdateOrderStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOrderStatusRequest {
    return new UpdateOrderStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOrderStatusRequest {
    return new UpdateOrderStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOrderStatusRequest | PlainMessage<UpdateOrderStatusRequest> | undefined, b: UpdateOrderStatusRequest | PlainMessage<UpdateOrderStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateOrderStatusRequest, a, b);
  }
}

